import React from 'react';
import { CircularProgress, Box } from '@mui/material';

function SectionLoader() {
  return (
    <Box 
      display="flex" 
      justifyContent="center" 
      alignItems="center" 
      height="100%" 
      width="100%"
    >
      <CircularProgress />
    </Box>
  );
}

export default SectionLoader;
